import { Box, Typography } from '@mui/material'
import { ReactElement } from 'react'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
}

export function CustomTabPanel(props: TabPanelProps): ReactElement {
  const { children, index, ...other } = props

  return (
    <div role="tabpanel" id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      <Box sx={{ p: 3 }}>
        <Typography component="div">{children}</Typography>
      </Box>
    </div>
  )
}
